import {observable} from 'mobx';

class FlowStoreClass {
  @observable isFlowClosed = true;
}

export const FlowStore = new FlowStoreClass();
